<div class="margin">
  <div class="flash-message-container">
    <flash-message></flash-message>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <div class="page-header">
        <h2>{{gleba.id ? 'Editando' : 'Novo'}} Talhão</h2>
      </div>
    </div>

    <div class="col-xs-12">
      <form id="gleba_form" name="gleba_form" novalidate ng-submit="save(gleba_form)">
        <div class="row">
          <div class="col-xs-6" ng-if="!gleba.id">
            <label>Propriedade</label>
            <ui-select ng-model="gleba.propriedade" theme="bootstrap" on-select="list($item)" ng-change="changePropriedade()">
              <ui-select-match placeholder="">{{$select.selected.descricao | capitalize}}</ui-select-match>
              <ui-select-choices repeat="propriedade in propriedadesGlebas | filter: $select.search">
                <span class="form-group" ng-bind-html="propriedade.descricao | capitalize | highlight: $select.search"></span>
              </ui-select-choices>
            </ui-select>
          </div>
          <div class="col-xs-6">
            <div class="form-group" ng-class="{'has-error': gleba_form.descricao.$invalid}">
              <label for="descricao">Descrição</label>
              <input autofocus class="form-control" ng-model="gleba.descricao" type="text" id="descricao" name="descricao" autocomplete="off" required>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-6">
            <div class="form-group" ng-class="{'has-error': gleba_form.area_propria.$invalid}">
              <label for="area_propria">Área Própria (ha)</label>
              <input class="form-control" ng-model="gleba.area_propria" type="number" min="0" id="area_propria" name="area_propria" autocomplete="off" required>
            </div>
          </div>
          <div class="col-xs-6">
            <div class="form-group" ng-class="{'has-error': gleba_form.area_arrendada.$invalid}">
              <label for="area_arrendada">Área Arrendada (ha)</label>
              <input class="form-control" ng-model="gleba.area_arrendada" type="number" min="0" id="area_arrendada" name="area_arrendada" autocomplete="off" required>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-6">
            <div class="form-group">
              <label for="kmlFile">Arquivo KML</label>
              <input file-input ng-model="kmlFile" type="file" id="kmlFile" name="kmlFile" ng-change="changeFile()">
            </div>
          </div>
          <div class="col-xs-6">
            <label>Importar de Demarcação de Área (Tipo geral)</label>
            <div class="width-100">
              <div class="form-group">
                <ui-select ng-disabled="!gleba.propriedade" ng-model="areaDemarcada" theme="bootstrap" id="areaDemarcada" name="areaDemarcada" ng-change="loadAreaDemarcada(areaDemarcada)" >
                  <ui-select-match placeholder="Área Demarcada">{{$select.selected.descricao}} ({{+$select.selected.area / 10000.0 | number:2}}ha)</ui-select-match>
                  <ui-select-choices repeat="areaDemarcada in areasDemarcadas | orderBy: '-created_at' | filter: $select.search">
                    <span class="form-group" ng-bind-html="areaDemarcada.descricao | highlight: $select.search"></span>
                  </ui-select-choices>
                </ui-select>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="form-group m-b-xs">
              <button class="btn btn-danger btn-sm" type="button" ng-click="excluirMapa()" ng-show="gleba.tem_kml">Excluir Mapa</button>
            </div>
          </div>
        </div>
        <ng-include src="'views/glebas/_mapa.html'"></ng-include>
        <div class="row pull-right padding-top-10">
          <div class="col-xs-12 btn-group">
            <button class="btn btn-default btn-sm btn-action" type="button" ng-click="goToIndex()">Cancelar</button>

            <button class="btn btn-success btn-sm btn-action" type="submit"
                    ng-disabled="gleba_form.$invalid" ng-if="permissions.glebas.canManage">
              Salvar <i class="fa fa-check"></i>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
